/**
 * 第三方相关
 *
 * https://yapi.gaoding.com/project/1536/interface/api/cat_20534
 */

import request from "../utils/request";

export function getDomain({ domain_id }) {
  return request({
    url: `/domains/${domain_id}`,
  });
}

export function getDomainPins({ domain_id, limit, max, since }) {
  return request({
    url: `/domains/${domain_id}/pins`,
    query: {
      limit,
      max,
      since,
    },
  });
}

export function followDomain({ domain_id }) {
  return request({
    url: `/domains/${domain_id}/follow`,
    method: "post",
  });
}

export function unfollowDomain({ domain_id }) {
  return request({
    url: `/domains/${domain_id}/follow`,
    method: "delete",
  });
}

export function getFollowingDomains({ urlname, limit, max, since }) {
  return request({
    url: `/${urlname}/following/domain`,
    query: {
      limit,
      max,
      since,
    },
  });
}

export function batchGetDomains({ ids }) {
  return request({
    url: "/domains",
    query: {
      ids,
    },
  });
}
